<template>
  <div class="ad-contain">
    <div class="ad-header">
      <div class="ad-header-title">
        工商亮照添加使用说明
      </div>
      <p class="ad-header-body">
        亮照申请通过后，会把亮照链接地址通过邮件的形式发送给您，您可以请网站开发人员按照以下步骤将亮照链接添加到您的网站。
      </p>
      <p class="ad-header-msg">
        <span>注：</span>为了防止不发分子盗用您的亮照， 亮照链接地址须嵌入到申请亮照时填写的网站之中才能打开
      </p>
    </div>
    <div class="ad-body">
      <div class="ad-items">
        <img src="../assets/images/01.png">
        <p>找到页面中放置亮照的位置。</p>
      </div>
      <div class="ad-info-items">
        <img src="../assets/images/ad-info1.png"/>
        <p class="ad-info-p1">请将亮照链接地址进行修改后复制到网站底部的代码中，修改内容为亮照图标尺寸大小：</p>
        <p class="ad-info-p2">•&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;script type="text/javascript" src="http://www.xx.com/getSiteBaseJs/196?widthimg=<span>40</span>&heightimg=<span>40</span>"&gt;&lt;/script&gt;&nbsp; 修改为合适尺寸；</p>
        <p class="ad-info-p3">示例：</p>
        <p class="ad-info-p4">&lt;script type="text/javascript" src="http://www.xx.com/getSiteBaseJs/196?widthimg=<span>24</span>&heightimg=<span>24</span>"&gt;&lt;/script&gt;</p>

      </div>
      <div class="ad-items">
        <img src="../assets/images/02.png">
        <p>点击亮照logo即可进入亮照首页查看。</p>
      </div>
      <div class="ad-info-items">
        <img src="../assets/images/ad-info2.png"/>
      </div>
      <div class="ad-items">
        <img src="../assets/images/03.png">
        <p>亮照有限制功能，必须嵌入自己申请时所填写域名网站中，否则就会404无法查看。</p>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'

export default {
  name: 'notebook',
  components: {
    'navigation': navigation
  },
  data() {
    return {
    }
  },
  created: function () {

  },
  methods: {
  }
}
</script>

<style>
@import '../assets/css/adv.css';

</style>




// WEBPACK FOOTER //
// src/components/notebook.vue